const dropdownStylesError = {
    option: (defaultStyles, state) => ({
        ...defaultStyles,
        color: '#000',
        backgroundColor: state.isSelected ? '#DFDFDF' : '#FFF',
        '&:hover': {
            backgroundColor: '#DFDFDF',
        },
        cursor: 'pointer'
    }),

    control: (defaultStyles, state) => ({
        ...defaultStyles,
        minHeight: 40,
        paddingVertical: 6,
        paddingHorizontal: 12,
        border: '1px solid #E85F5C',
        boxShadow: state.isFocused ? '#E85F5C' : 'none',
        '&:hover': {
            border: '1px solid #E85F5C',
            boxShadow: '#E85F5C'
        }
    }),

    indicatorSeparator: (defaultStyles) => ({
        ...defaultStyles,
        display: 'none'
    }),

    dropdownIndicator: (defaultStyles) => ({
        ...defaultStyles,
        color: '#767676'
    }),

    singleValue: (defaultStyles) => ({ ...defaultStyles, color: '#000' })
}

export default dropdownStylesError